import { render, staticRenderFns } from "./ScopeSaveForm.vue?vue&type=template&id=790406cd"
import script from "./ScopeSaveForm.vue?vue&type=script&lang=js"
export * from "./ScopeSaveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports